import React from 'react'
import Seo from '../components/seo'
import styles from './iscriviti.module.css'
import Layout from '../components/layout'
import FormSignin from '../components/form-signin'
import { Grid, Typography } from '@material-ui/core'

class Iscriviti extends React.Component {
  render() {
    const pageTitle = 'Movimento Rivoluzione Fiscale - Iscriviti'

    return (
      <Layout location={this.props.location}>
        <Seo title="Iscriviti al MRF" description="Pagina ufficiale di adesione al Movimento Rivoluzione Fiscale, con modulo di iscrizione e informativa privacy." path="/iscriviti/" />
        <div className={styles.container}>
          <div className={styles.gridContainer}>
            <Grid container spacing={2} className={styles.documentsContainer}>
              <Grid item xs={12} className={styles.titleContainer}>
                <Typography variant={'h1'} className={styles.title}>
                  Iscriviti al Movimento Rivoluzione Fiscale
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <figure className={styles.familyScene}>
                  <img src="/mrf-famiglia.jpg" width="1600" height="900" alt="Famiglia e comunità del Movimento Rivoluzione Fiscale" />
                </figure>
              </Grid>
              <FormSignin />
            </Grid>
          </div>
        </div>
      </Layout>
    )
  }
}

export default Iscriviti
